import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MetricsCard = styled(Box)(({ theme }) => ({
  gridArea: 'metrics',
  border: '1px solid rgba(221, 221, 234, 1)',
  padding: '13px 20px 20px',
  borderRadius: '6px',
  height: 'fit-content',
  minWidth: '200px',

  [theme.breakpoints.down('md')]: {
    minWidth: 'unset',
  },

  [theme.breakpoints.down('sm')]: {
    marginTop: '17px',
    border: 'none',
    padding: '0',
  },
}));

export const MetricsCardTitle = styled(Typography)(() => ({
  fontWeight: '700',
  color: 'rgba(1, 128, 148, 1)',
  textAlign: 'center',
  marginBottom: '9px',
}));

export const CollapsesContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  marginTop: '20px',
}));
